import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Login } from './login/login';

export const appRoutes: Routes = [
    {
        path: 'ops',
        loadChildren: () =>
            import('./operations/operations-route').then(m => m.operationRoutes),
    },
    {
            path: ':marketId', component: Login,
    },
    {
            path: 'login/:marketId', component: Login,
    }
];